



































import { Component, Vue } from 'vue-property-decorator';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import CloseIcon from '@/components/icons/Close.vue';
import segmentIo from '@/utils/segment.io';

const SHOPIFY_EXTENSION_URL =
  'https://www.shopify.com/admin/settings/checkout/';

const LEAN_MORE_URL =
  'https://support.twism.com/hc/en-us/articles/34074429495309-Installing-Shopify-Extension';

@Component({
  components: {
    Typography,
    CloseIcon
  }
})
export default class ShopifyExtensionBanner extends Vue {
  async onClick() {
    segmentIo.track('Clicked Install Shopify UI Extension');

    window.open(SHOPIFY_EXTENSION_URL, '_blank');
  }

  async onLearnMoreClick() {
    segmentIo.track('Clicked Shopify Extension Learn More');

    window.open(LEAN_MORE_URL, '_blank');
  }

  async onClose() {
    segmentIo.track('Clicked Shopify Extension Banner Close');
    this.$emit('onBannerClose');
  }

  mounted() {
    segmentIo.track('Shopify Extension Banner Rendered');
  }
}
